// extracted by mini-css-extract-plugin
export default {"wrapper":"bla-z","play":"cla-z"};